module.exports = __webpack_public_path__ + "img/heytmall_bg.61853d90.jpg";